export const GET_SUPPLIERS = 'GET_SUPPLIERS';
export const CREATE_SUPPLIER = 'CREATE_SUPPLIER';
export const REMOVE_SUPPLIER = 'REMOVE_SUPPLIER';
export const UPDATE_SUPPLIER = 'UPDATE_SUPPLIER';
